/**
 * Stripe JS loader.
 *
 * loadStripe() is async + heavy — memoise the Promise so we only call it
 * once per app lifetime, regardless of how many routes use Elements.
 */

import { loadStripe } from '@stripe/stripe-js';

let stripePromise;

export function getStripe() {
  if (!stripePromise) {
    const key = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
    if (!key || key === 'pk_test_REPLACE_ME') {
      console.warn(
        '[stripe] VITE_STRIPE_PUBLIC_KEY is not set. Copy a pk_test_... key from '
        + 'the TocynTicket Stripe dashboard into .env.local before running the app.',
      );
    }
    stripePromise = loadStripe(key);
  }
  return stripePromise;
}
